<template>
  <div
    v-if="value != null"
    rounded
    elevation="0"
    :class="color"
    class="px-4 py-2 rounded-pill text-right font-weight-bold text-center"
  >
    {{ value | percentage }}
  </div>
  <div v-else class="text-center">--</div>
</template>

<script>
import numeral from "numeral";
import { agreeColors } from "../constants/Survey";

export default {
  filters: {
    percentage(val) {
      return numeral(val).format("0.00%");
    },
  },
  props: {
    value: Number,
    small: Boolean
  },
  computed: {
    color() {
      for (let i = 0; i < agreeColors.length; i++) {
        if (this.value >= agreeColors[i].floor) {
          return agreeColors[i].classes;
        }
      }
      return null;
    },
  },
};
</script>
